import GraphQLJSON from 'graphql-type-json';

const typeResolvers = {};

const resolvers = {
  JSON: GraphQLJSON,
};

const saveOrder = (globalOutletId, companyId) => {
  return {
    companyCarts: [
      {
        companyId: '470041',
        cartItems: [],
        numberOfItems: 0,
        _typename: 'CompanyCart',
      },
      {
        companyId: '470042',
        cartItems: [
          {
            id: '3',
            skunitId: '28',
            mrp: 23,
            skunitName: 'Surf Excel Easy Wash 200gm, Rs.23/-',
            pictureUrl:
              'https://s3-ap-southeast-1.amazonaws.com/bizompictures/SURF-XL-EASY-WASH-1.5KG2151178214058491511782140.png',
            price: 21.2,
            discountedPrice: 20.2,
            margin: 1.8,
            discountMargin: 1.0,
            finalMargin: 2.8,
            units: 1,
            cases: 0,
            unitsPerCase: 1,
            inventory: null,
            __typename: 'CartItem',
          },
        ],
        numberOfItems: 1,
        errors: ['Order for minimum 200 value', 'Insufficient inventory'],
        _typename: 'CompanyCart',
      },
    ],
    items: [
      {
        id: '3',
        skunitId: '28',
        companyId: '470042',
        price: 21.2,
        units: 1,
        cases: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'CartItem',
      },
    ],
    numberOfItems: 1,
    _typename: 'RetailerCart',
  };
};

const updateCart = (
  globalOutletId,
  companyId,
  { skunitId, price, cases, units, warehouseId, warehouseName }
) => {
  return {
    companyId: '470041',
    cartItems: [
      {
        id: '1',
        skunitId: '18',
        mrp: 40,
        skunitName: 'Cadbury Dairy Milk Fruit &amp; Nut 38gm, Rs.40/-',
        pictureUrl:
          'https://s3-ap-southeast-1.amazonaws.com/bizompictures/Cadbury-Dairy-Milk-Silk-Fruit-And-Nut-55Gm151021811222521510218112.png',
        price: 35.71,
        discountedPrice: 30.71,
        margin: 4.29,
        discountMargin: 5.0,
        finalMargin: 9.29,
        units: 2,
        cases: 0,
        unitsPerCase: 1,
        inventory: [
          {
            allowOrderWithoutInventory: 0,
            availableInventory: 2000,
            marginPercent: 10.725,
            mrp: 40,
            price: 35.71,
            vat: 0,
            __typename: 'Inventory',
          },
        ],
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'CartItem',
      },
      {
        id: '2',
        skunitId: '19',
        mrp: 45,
        name: 'Cadbury Dairy Milk Roast & Almond 38gm, Rs.45/-',
        pictureUrl:
          'https://s3-ap-southeast-1.amazonaws.com/bizompictures/Cadbury__Dairy_Milk_Roast_Almond_38gm__Chocolate_15009632541798624032151426943213481514269432.png',
        price: 40.27,
        discountedPrice: 35.27,
        margin: 4.73,
        discountMargin: 5.0,
        finalMargin: 9.73,
        units: 2,
        cases: 1,
        unitsPerCase: 1,
        inventory: [
          {
            allowOrderWithoutInventory: 0,
            availableInventory: 2000,
            marginPercent: 10,
            mrp: 40,
            price: 36,
            vat: 14.5,
            __typename: 'Inventory',
          },
        ],
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'CartItem',
      },
    ],
    numberOfItems: 2,
    _typename: 'CompanyCart',
  };
};

const fetchCart = globalOutletId => {
  return {
    companyCarts: [
      {
        companyId: '470041',
        cartItems: [
          {
            id: '1',
            skunitId: '18',
            mrp: 40,
            skunitName: 'Cadbury Dairy Milk Fruit &amp; Nut 38gm, Rs.40/-',
            pictureUrl:
              'https://s3-ap-southeast-1.amazonaws.com/bizompictures/Cadbury-Dairy-Milk-Silk-Fruit-And-Nut-55Gm151021811222521510218112.png',
            price: 35.71,
            discountedPrice: 30.71,
            margin: 4.29,
            discountMargin: 5.0,
            finalMargin: 9.29,
            units: 1,
            cases: 0,
            unitsPerCase: 1,
            appliedSchemes: [
              {
                id: '1',
                name: 'Buy one get 1',
              },
              {
                id: '2',
                name: 'Extra 1% off',
              },
              {
                id: '3',
                name: 'Buy one get 1',
              },
              {
                id: '4',
                name: 'Buy one get 1',
              },
              {
                id: '5',
                name: 'Buy one get 1',
              },
            ],
            freeForSkunitId: [],
            isFree: false,
            warehouseId: '11',
            warehouseName: 'Test',
            __typename: 'CartItem',
          },
          {
            id: '2',
            skunitId: '19',
            mrp: 45,
            name: 'Cadbury Dairy Milk Roast & Almond 38gm, Rs.45/-',
            pictureUrl:
              'https://s3-ap-southeast-1.amazonaws.com/bizompictures/Cadbury__Dairy_Milk_Roast_Almond_38gm__Chocolate_15009632541798624032151426943213481514269432.png',
            price: 40.27,
            discountedPrice: 35.27,
            margin: 4.73,
            discountMargin: 5.0,
            finalMargin: 9.73,
            units: 2,
            cases: 1,
            unitsPerCase: 1,
            appliedSchemes: [],
            freeForSkunitId: ['18'],
            isFree: true,
            warehouseId: '11',
            warehouseName: 'Test',
            __typename: 'CartItem',
          },
        ],
        numberOfItems: 2,
        errors: [],
        _typename: 'CompanyCart',
      },
      {
        companyId: '470042',
        cartItems: [
          {
            id: '3',
            skunitId: '28',
            mrp: 23,
            skunitName: 'Surf Excel Easy Wash 200gm, Rs.23/-',
            pictureUrl:
              'https://s3-ap-southeast-1.amazonaws.com/bizompictures/SURF-XL-EASY-WASH-1.5KG2151178214058491511782140.png',
            price: 21.2,
            discountedPrice: 20.2,
            margin: 1.8,
            discountMargin: 1.0,
            finalMargin: 2.8,
            units: 1,
            cases: 0,
            unitsPerCase: 1,
            appliedSchemes: [
              {
                id: '5',
                name: 'Get 5% off',
              },
              {
                id: '6',
                name: 'Buy one get 1',
              },
              {
                id: '3',
                name: '10% off',
              },
            ],
            freeForSkunitId: [],
            isFree: false,
            __typename: 'CartItem',
          },
        ],
        numberOfItems: 1,
        errors: [],
        _typename: 'CompanyCart',
      },
    ],
    items: [
      {
        id: '1',
        skunitId: '18',
        companyId: '470041',
        cutoffTime: '01:00:00',
        price: 35.71,
        units: 2,
        cases: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'SavedCartItem',
      },
      {
        id: '2',
        skunitId: '19',
        companyId: '470041',
        cutoffTime: '',
        price: 40.27,
        units: 2,
        cases: 1,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'SavedCartItem',
      },
      {
        id: '3',
        skunitId: '28',
        companyId: '470042',
        cutoffTime: '18:00:00',
        price: 21.2,
        units: 1,
        cases: 0,
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'SavedCartItem',
      },
    ],
    numberOfItems: 3,
    _typename: 'RetailerCart',
  };
};

const deleteItem = (globalOutletId, cartItemId) => {
  return {
    companyId: '470041',
    cartItems: [
      {
        id: '1',
        skunitId: '18',
        mrp: 40,
        skunitName: 'Cadbury Dairy Milk Fruit &amp; Nut 38gm, Rs.40/-',
        pictureUrl:
          'https://s3-ap-southeast-1.amazonaws.com/bizompictures/Cadbury-Dairy-Milk-Silk-Fruit-And-Nut-55Gm151021811222521510218112.png',
        price: 35.71,
        discountedPrice: 30.71,
        margin: 4.29,
        discountMargin: 5.0,
        finalMargin: 9.29,
        units: 2,
        cases: 0,
        unitsPerCase: 1,
        inventory: [
          {
            allowOrderWithoutInventory: 0,
            availableInventory: 2000,
            marginPercent: 10.725,
            mrp: 40,
            price: 35.71,
            vat: 0,
            __typename: 'Inventory',
          },
        ],
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'CartItem',
      },
      {
        id: '2',
        skunitId: '19',
        mrp: 45,
        name: 'Cadbury Dairy Milk Roast & Almond 38gm, Rs.45/-',
        pictureUrl:
          'https://s3-ap-southeast-1.amazonaws.com/bizompictures/Cadbury__Dairy_Milk_Roast_Almond_38gm__Chocolate_15009632541798624032151426943213481514269432.png',
        price: 40.27,
        discountedPrice: 35.27,
        margin: 4.73,
        discountMargin: 5.0,
        finalMargin: 9.73,
        units: 2,
        cases: 1,
        unitsPerCase: 1,
        inventory: [
          {
            allowOrderWithoutInventory: 0,
            availableInventory: 2000,
            marginPercent: 10,
            mrp: 40,
            price: 36,
            vat: 14.5,
            __typename: 'Inventory',
          },
        ],
        warehouseId: '11',
        warehouseName: 'Test',
        __typename: 'CartItem',
      },
    ],
    numberOfItems: 2,
    _typename: 'CompanyCart',
  };
};

const mocks = {
  Query: {
    cart: (_, { globalOutletId }) => fetchCart(globalOutletId),
  },
  Mutation: {
    executeCart: (_, { globalOutletId, companyId }) =>
      saveOrder(globalOutletId, companyId),
    updateCartItemForCompany: (_, { globalOutletId, companyId, cartItem }) =>
      updateCart(globalOutletId, companyId, cartItem),
    cancelCartItem: (_, { globalOutletId, cartItemId }) =>
      deleteItem(globalOutletId, cartItemId),
  },
};

export { resolvers, typeResolvers, mocks };
